import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.scss';
import ChatPage from './pages/chat/ChatPage';
import ResearchPage from './pages/research/ResearchPage';
import PromptsPage from './pages/admin/prompts/PromptsPage';
import NotFound from './pages/NotFound/NotFound';
import LoginPage from './pages/auth/LoginPage';
import AuthenticatePage from './pages/auth/AuthenticatePage';
import UnauthorizedPage from './pages/auth/UnauthorizedPage';
import { ProtectedRoutes } from './components/ProtectedRoutes';
import EvaluationsPage from './pages/admin/evaluations/EvaluationsPage';
import BenchmarkQuestionsPage from './pages/admin/benchmark/BenchmarkQuestionsPage';
import SummaryTestPage from './pages/admin/summary/SummaryTestPage';
import AdminLayout from './components/layout/AdminLayout/AdminLayout';
import MainLayout from './components/layout/MainLayout';
import DocumentUploadPage from './pages/admin/documents/DocumentUploadPage';
import SearchTestPage from './pages/admin/search/SearchTestPage';
import SignalSearchPage from './pages/search/SignalSearchPage';
import Page from './components/layout/Page';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth routes */}
        <Route
          path="/login"
          element={
            <Page title="Login">
              <LoginPage />
            </Page>
          }
        />
        <Route
          path="/authenticate"
          element={
            <Page title="Authenticate">
              <AuthenticatePage />
            </Page>
          }
        />
        <Route
          path="/unauthorized"
          element={
            <Page title="Unauthorized">
              <UnauthorizedPage />
            </Page>
          }
        />

        {/* Protected routes that only require authentication */}
        <Route element={<ProtectedRoutes />}>
          <Route element={<MainLayout />}>
            <Route
              path="/research"
              element={
                <Page title="Research">
                  <ResearchPage />
                </Page>
              }
            />
            <Route
              path="/chat"
              element={
                <Page title="Chat">
                  <ChatPage />
                </Page>
              }
            />
            <Route
              path="/search"
              element={
                <Page title="Signal Search">
                  <SignalSearchPage />
                </Page>
              }
            />
            <Route path="/" element={<Navigate to="/research" replace />} />
          </Route>
        </Route>

        {/* Protected routes that require admin role */}
        <Route element={<ProtectedRoutes requiredRole="admin" />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={null} />
            <Route
              path="prompts"
              element={
                <Page title="Prompts - Admin">
                  <PromptsPage />
                </Page>
              }
            />
            <Route
              path="evals"
              element={
                <Page title="Evaluations - Admin">
                  <EvaluationsPage />
                </Page>
              }
            />
            <Route
              path="benchmark"
              element={
                <Page title="Benchmark - Admin">
                  <BenchmarkQuestionsPage />
                </Page>
              }
            />
            <Route
              path="summary-test"
              element={
                <Page title="Summary Test - Admin">
                  <SummaryTestPage />
                </Page>
              }
            />
            <Route
              path="document-upload"
              element={
                <Page title="Document Upload - Admin">
                  <DocumentUploadPage />
                </Page>
              }
            />
            <Route
              path="search-test"
              element={
                <Page title="Search Test - Admin">
                  <SearchTestPage />
                </Page>
              }
            />
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
